module.exports = __webpack_public_path__ + "img/Wp_2053.0f661416.png";